export enum TransportationFormDirection {
  Pick = 'pick',
  Drop = 'drop',
}
